if (!customElements.get('sc-home-review-photos')) {
  class SCHomeReviewPhotos extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('[data-sc-home-review-dialog]');
      this.image = this.querySelector('[data-sc-home-review-dialog-image]');
      this.heading = this.querySelector('[data-sc-home-review-dialog-heading]');
      if (!this.dialog || !this.image || !this.heading) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('[data-sc-home-review-photo]').forEach((link) => {
        link.setAttribute('aria-haspopup', 'dialog');
        link.addEventListener('click', (event) => {
          if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.openPhoto(link);
        }, options);
      });
      this.querySelector('[data-sc-home-review-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => {
        if (this.dialog.open) return;
        this.syncScrollLock();
        if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
    }
    openPhoto(link) {
      this.trigger = link;
      this.image.src = link.dataset.scHomeReviewLarge;
      this.image.alt = link.dataset.scHomeReviewAlt;
      this.heading.textContent = link.dataset.scHomeReviewAlt;
      if (!this.dialog.open) this.dialog.showModal();
      this.syncScrollLock();
    }
    syncScrollLock() {
      document.documentElement.classList.toggle('sc-home-review-photo-is-open', Boolean(document.querySelector('[data-sc-home-review-dialog][open]')));
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
      this.syncScrollLock();
    }
  }
  customElements.define('sc-home-review-photos', SCHomeReviewPhotos);
}
